import { AlertCircle, Loader2, RotateCcw } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface ErrorStateProps {
  title: string
  description?: string
  onRetry: () => void
  isRetrying?: boolean
  className?: string
}

/**
 * Einheitlicher Fehlerzustand fuer fehlgeschlagene Queries (M5-A):
 * Icon + deutsche Meldung + "Erneut versuchen"-Button, der neu laedt.
 * Pendant zum EmptyState (components/empty-state.tsx).
 */
export function ErrorState({ title, description, onRetry, isRetrying = false, className }: ErrorStateProps) {
  return (
    // F02: Semantische Fehlerfarbe (--destructive), kein Marken-Pastell.
    // Ladezustand wird per aria-busy angekündigt, nicht als blanket-live.
    <div
      role="alert"
      aria-busy={isRetrying || undefined}
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-destructive/40 px-6 py-12 text-center',
        className,
      )}
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-destructive/10">
        <AlertCircle className="h-5 w-5 text-destructive" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-sm font-semibold text-foreground">{title}</h3>
      {description && <p className="mt-1 max-w-xs text-sm text-muted-foreground">{description}</p>}
      <Button onClick={onRetry} variant="outline" disabled={isRetrying} className="mt-5">
        {isRetrying ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
        ) : (
          <RotateCcw className="mr-2 h-4 w-4" aria-hidden="true" />
        )}
        Erneut versuchen
      </Button>
    </div>
  )
}
